<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Delivery Staff Details",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Delivery Staff Details",
            items: [
               {
                  text: "Delivery Staffs",
                  href: "/delivery-staffs",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],

            staff: {},
            token: '',

         };
      },
      mounted() {
    
      },

      created() {
         this.fetchStaff();
      },

      methods: {

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         fetchStaff() {
            let url = "api/admin/delivery-staff/details?id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.staff = responseData.deliverystaff;  
                     
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

        
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- listing table starts -------->
                  <div class="row">
                     <div class=" col-md-6 col-lg-6">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           
                           <div class="table-responsive">
                              <table class="table mb-0">
                                 <tbody>                                    
                                    
                                    <tr>
                                       <th>Name</th>
                                       <th>:</th>
                                       <td>{{staff.name}}</td>
                                    </tr>                                                       
                                    <tr>
                                       <th>Mobile</th>
                                       <th>:</th>
                                       <td>+91 {{staff.mobile}}</td>
                                    </tr>           

                                    <tr>
                                       <th>Email</th>
                                       <th>:</th>
                                       <td>{{staff.email}}</td>
                                    </tr>           

                                    <tr>
                                       <th>Whatsapp</th>
                                       <th>:</th>
                                       <td>+91 {{staff.whatsapp}}</td>
                                    </tr>                      

                                    <tr>
                                       <th>Address</th>
                                       <th>:</th>
                                       <td>
                                          <span v-if="staff.address">{{staff.address}}</span>
                                       </td>
                                    </tr>           
                                    
                                    
                                    <tr>
                                       <th>Created on</th>
                                       <th>:</th>
                                       <td>{{staff.converted_created_at}}</td>
                                    </tr>           

                                 </tbody>
                              </table>
                           </div>
                        </b-card>
                     </div>
                     <div class=" col-md-6 col-lg-6">
                      
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">ID Proof</h4>

                           <a :href="$image_url + staff.id_proof" target="_blank" v-if="staff.id_proof">
                              <img :src="$image_url + staff.id_proof" alt="ID Proof" class="avatar-md">
                           </a>

                           <img v-else src="@/assets/images/no-image.png" alt="ID Proof" class="avatar-md">
                        </b-card>
                     </div>
                  </div>
                  <!---- listing table ends -------->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
